import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/dex-shared/store/user';
import questions from './modules/questions';
import articles from './modules/articles';
import solutions from './modules/solutions';
import exams from './modules/exams';
import examGroups from './modules/examGroups';
import lists from './modules/lists';
import boards from './modules/boards';
import teachers from './modules/teachers';
import classrooms from './modules/classrooms';
import courses from './modules/courses';
import feedbackQuestions from './modules/feedbackQuestions';
import reports from './modules/reports';
import boardSections from './modules/boardSections';
import boardSubsections from './modules/boardSubsections';
import descomplica from './modules/descomplica';
import treeKnowledges from './modules/treeKnowledges';
import oldKnowledges from './modules/oldKnowledges';
import users from './modules/users';
import examinationBoards from './modules/examinationBoards';
import institutions from './modules/institutions';
import examApplications from './modules/examApplications';
import dex from './dex';
import app from './app';
import postgrad from './postgrad';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    questions,
    articles,
    solutions,
    exams,
    examGroups,
    lists,
    boards,
    teachers,
    classrooms,
    courses,
    feedbackQuestions,
    reports,
    boardSections,
    boardSubsections,
    oldKnowledges,
    descomplica,
    treeKnowledges,
    users,
    examinationBoards,
    institutions,
    examApplications,
    dex,
    app,
    postgradModules: postgrad,
  },
});
